import { useKeyboardShortcuts } from "@/hooks/use-keyboard-shortcuts";
import { useLocalStorage } from "@/hooks/use-local-storage";
import { mockStats } from "@/lib/mock-data";
import { Outlet } from "@tanstack/react-router";
import { useState } from "react";
import { Toaster } from "sonner";
import { CommandPalette } from "./command-palette";
import { Sidebar } from "./sidebar";
import { Topbar } from "./topbar";

export function RootLayout() {
	const [sidebarCollapsed, setSidebarCollapsed] = useLocalStorage("sidebar-collapsed", false);
	const [commandPaletteOpen, setCommandPaletteOpen] = useState(false);

	useKeyboardShortcuts({
		"mod+k": () => setCommandPaletteOpen(true),
	});

	return (
		<div className="flex h-screen w-screen overflow-hidden bg-background">
			<Sidebar
				collapsed={sidebarCollapsed}
				onToggle={() => setSidebarCollapsed(!sidebarCollapsed)}
			/>

			<div className="flex-1 flex flex-col min-w-0">
				<Topbar
					onOpenCommandPalette={() => setCommandPaletteOpen(true)}
					pendingCount={mockStats.pendingReview}
				/>

				<main className="flex-1 overflow-auto">
					<Outlet />
				</main>
			</div>

			<CommandPalette open={commandPaletteOpen} onOpenChange={setCommandPaletteOpen} />

			<Toaster
				position="bottom-right"
				toastOptions={{
					className: "bg-card border-border text-foreground shadow-xl",
					style: {
						background: "var(--card)",
						border: "1px solid var(--border)",
						color: "var(--foreground)",
					},
				}}
			/>
		</div>
	);
}
